const PropTypes = require('prop-types');
const React = require('react');

const StorySummary = require('./brokerStorySummary');
const { OKLink } = require('commonsComponents/OKLink');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');

const {
    DATE_FORMAT_ES,
    BROKER_MAX_MORE_NEWS,
    DATE_FORMAT_SHORT_TIME_24
} = require('constants/index');
const DateHelper = require('utilities/dateHelper');
const { formatText } = require('core/i18n').i18n;



class MoreNews extends React.Component {
    buildContent() {
        const {
            immBrokerNews,
            pageName
        } = this.props;
        const newsData = immBrokerNews.get('byOrder');
        const stories = newsData.slice(1, BROKER_MAX_MORE_NEWS).map((pulseId, index) => {
            const immNews = immBrokerNews.getIn(['byId', pulseId]);
            const parsedDate = `${DateHelper.buildFormattedDate(immNews.get('date'), DATE_FORMAT_ES)} - ${DateHelper.buildFormattedDate(immNews.get('date'), DATE_FORMAT_SHORT_TIME_24)}`;
            const objId = `broker-news-pulse-${index}`;
            return (
                <OKLink modifier="emphasize" key={objId} className="broker-news-market-pulse" to={`/myprofile/broker/news/${immNews.get('id')}`} tabIndex="-1">
                    <StorySummary
                        myDate={parsedDate}
                        title={immNews.get('titulo')}
                        summary=""
                        readMore={false}
                        colorTitle="blue"
                        newsSection={true}
                        pageName={pageName}
                    />
                </OKLink>
            );
        });

        return stories;
    }

    render() {
        const {
            immBrokerNews
        } = this.props;

        if (immBrokerNews.get('isFetching')) {
            return (<LoadingSection />);
        }

        if (immBrokerNews.get('error')) {
            return (<p>Ha ocurrido un error</p>);
        }

        const moreNews = this.buildContent();

        if (moreNews.size === 0) {
            const primaryText = formatText('broker-emptyNews');
            return (
                <EmptyState
                    primaryText={primaryText}
                    iconType="noitems-wealth"  />
            );
        } else {
            return (
                <div>
                    {moreNews}
                </div>
            );
        }
    }
}

MoreNews.propTypes = {
    immBrokerNews: PropTypes.object.isRequired,
    requestNews: PropTypes.func.isRequired,
    pageName: PropTypes.string
}

module.exports = MoreNews;
